<template>
  <v-container fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" lg="8" justify="center" align="center">
        <base-material-card
          id="edit-operational"
          color="primary"
          icon="mdi-pencil"
          class="px-4 py-3"
        >
          <template v-slot:after-heading>
            <div class="title text-no-wrap font-weight-bold">
              {{ $t("equipmentProfile.equipment") }}
              {{ equipmentProfile.equipTag }}
            </div></template
          >

          <form v-if="equipmentProfile">
            <v-card-text>
              <base-subheading subheading="Operational Values" />
              <v-row class="mx-auto" justify="space-around">
                <v-col
                  cols="12"
                  md="6"
                  v-for="(opVal, index) in equipmentProfile.operationalValues"
                  :key="opVal.code"
                >
                  <validation-provider
                    v-slot="{ errors }"
                    rules="required"
                    :name="$t(`variables.${opVal.code}`)"
                  >
                    <v-text-field
                      v-model="equipmentProfile.operationalValues[index].value"
                      :error-messages="errors"
                      color="gray"
                      :hint="
                        `${$options.filters.capitalize(opVal.type)} (${unit(
                          opVal.type
                        )})`
                      "
                      :label="$t(`variables.${opVal.code}`)"
                      persistent-hint=""
                      validate-on-blur
                    />
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions
              ><v-spacer></v-spacer>
              <v-btn
                @click="submit"
                rounded
                color="primary"
                width="250"
                :x-large="$vuetify.breakpoint.mdAndUp"
                >{{ $t("newEquipment.submit") }}</v-btn
              ><v-spacer></v-spacer>
            </v-card-actions>
          </form>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { unitDefault } from "@/settings/unitTypes";

import readValues from "@/mixins/readValues";
import writeValues from "@/mixins/writeValues";
export default {
  computed: {
    ...mapState("equipments", ["equipmentProfile"]),
    ...mapGetters("auth", ["isMetric"])
  },
  async created() {
    const loading = this.$vs.loading({
      background: "#730D0B",
      color: "rgb(255, 255, 255)",
      opacity: 1,
      type: "square"
    });
    await this.$store.dispatch(
      "equipments/bindAnEquipment",
      this.$route.params.id
    );
    this.setValues();
    loading.close();
  },
  mixins: [writeValues, readValues],
  methods: {
    readValue(variable) {
      if (variable?.type === "unique") {
        return variable.value;
      }
      if (this.isMetric) {
        return parseFloat(variable?.value).toFixed(2);
      } else {
        let unit = this.unit(variable?.type);
        return parseFloat(
          this.transformUnit(variable?.value, variable?.type, unit)
        ).toFixed(2);
      }
    },
    setValues() {
      let dis = this;
      dis.equipmentProfile.operationalValues.forEach(v => {
        v.value = dis.readValue(v);
        // transforma la variable si no es metrico a metrico.
      });
    },
    transformValue(variable) {
      if (variable?.type === "unique") {
        return variable.value;
      }
      // transforma la variable si no es metrico a metrico.
      if (this.isMetric) {
        return parseFloat(variable?.value);
      } else {
        let unit = this.unit(variable?.type);

        return parseFloat(this.saveUnit(variable?.value, variable?.type, unit));
      }
    },
    async submit(ev) {
      ev.preventDefault();
      const loading = this.$vs.loading({
        background: "#730D0B",
        color: "rgb(255, 255, 255)",
        opacity: 1,
        type: "square"
      });
      const dis = this;
      this.equipmentProfile?.operationalValues?.forEach(variable => {
        variable.value = dis.transformValue(variable);
      });
      this.equipmentProfile.updateAt = new Date();
      let payload = {
        doc: this.equipmentProfile.id,
        db: "equipments",
        data: this.equipmentProfile
      };
      try {
        await this.$store.dispatch("updateDocument", payload);
        loading.close();
        this.$dialog.notify.success(
          "Equipment was created successfully, you will be redirect",
          {
            position: "top-right",
            timeout: 5000
          }
        );
        this.setValues();
        setTimeout(() => {
          this.$router.push("/equipment/" + this.equipmentProfile.id);
        }, 4000);
      } catch (error) {
        this.$dialog.notify.error(error, {
          position: "top-right",
          timeout: 5000
        });
      }
    },
    unit(item) {
      // Selecciona el Unit por defecto segun el perfil del usuario
      return this.isMetric
        ? unitDefault[item].metric
        : unitDefault[item].imperial;
    }
  }
};
</script>

<style></style>
